/**
 * Handles accordion opening and closing
 * @param {Object} element - Block
 */
export const accordionHandler = (element) => {
  const accordions = element.querySelectorAll(".accordion");
  accordions.forEach((accordion, index) => {
    const header = accordion.querySelector('.accordion-header');
    const display = accordion.querySelector(".accordion-display");
    let height = display.offsetHeight;
    if (document.body.classList.contains('page-overview') || document.body.classList.contains('page-contact')) {
      if (index != 0) {
        display.style.height = 0;
      } else {
        display.style.height = `${height}px`
        accordion.querySelector('.plusminus').classList.toggle('active')
      }
    } else {
      display.style.height = 0;
    }
    header.addEventListener("click", (evt) => {
      if (!evt.target.classList.contains('plusminus')) {
        accordion.querySelector('.plusminus').classList.toggle('active')
      }
      if (display.offsetHeight == 0) {
        display.style.height = `${height}px`
      } else {
        display.style.height = '0px'
      }
    });
  });
};
